// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { NotificationQuery } from './notification-query';
import { NotificationQueryEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TemplateVariable extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String(100) */
  customHandlerName?: string;
  /** String(500) */
  description?: string;
  /** String(200) */
  displayName!: string;
  /** String(50) */
  formatString?: string;
  /** Boolean */
  isActive!: boolean;
  /** Boolean */
  isList!: boolean;
  /** String(100) */
  name!: string;
  /** Enum FK notificationQuery */
  notificationQueryId!: NotificationQueryEnum;
  /** String(100) */
  parentListName?: string;
  /** String(500) */
  propertyPath!: string;
  /** Int32 */
  sortOrder!: number;
  /** String(100) */
  sourceEntityType!: string;
  /** FK notificationQueryId */
  notificationQuery!: NotificationQuery;
}

